import { ThemeOverride } from '@abstractTypes/theme'
import { fonts } from '@theme/index'

export const tvTheme: ThemeOverride = {
  colors: {
    primaryDark: '#333E4E',
    primaryDarkPressed: '#1A1F27',
    primaryLight: '#FFFFFF',
    primaryLightPressed: '#F6F6F6',
    inactive: '#76797C',
    outline: '#C4C9CF',
    background: '#EDEFF1',
    highlight01: '#333E4E',
    highlight01Pressed: '#1A1F27',
    highlight02: '#333E4E',
    highlight02Pressed: '#1A1F27',
    highlight03: '#333E4E',
    highlight04: '#504BD6',
    functional01: '#990000',
    functional02: '#489F2D',
    functional03: '#F2B140',
  },
  fonts: {
    ...fonts,
    heading0: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 85,
        tablet: 68,
        tabletMini: 60,
      },
      lineHeight: {
        tower: 109,
        tablet: 86,
        tabletMini: 67,
      },
    },
    heading1: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 60,
        tablet: 56,
        tabletMini: 48,
      },
      lineHeight: {
        tower: 68,
        tablet: 62,
        tabletMini: 60,
      },
    },
    heading2: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 40,
        tablet: 40,
        tabletMini: 34,
      },
      lineHeight: {
        tower: 48,
        tablet: 48,
        tabletMini: 46,
      },
    },
    heading3: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 34,
        tablet: 34,
        tabletMini: 28,
      },
      lineHeight: {
        tower: 44,
        tablet: 44,
        tabletMini: 36,
      },
    },
    heading4: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
        bold: 600,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 36,
        tablet: 36,
        tabletMini: 30,
      },
    },
    heading5: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
        bold: 600,
      },
      fontSize: {
        tower: 20,
        tablet: 20,
        tabletMini: 18,
      },
      lineHeight: {
        tower: 30,
        tablet: 26,
        tabletMini: 28,
      },
    },
    body: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
        bold: 600,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    label: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 14,
        tablet: 14,
        tabletMini: 12,
      },
      lineHeight: {
        tower: 24,
        tablet: 24,
        tabletMini: 18,
      },
    },
    cta: {
      fontFamily: 'Poppins',
      weight: {
        regular: 600,
        bold: 600,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    link: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 30,
        tablet: 30,
        tabletMini: 26,
      },
    },
    caption: {
      fontFamily: 'Poppins',
      weight: {
        regular: 600,
      },
      fontSize: {
        tower: 13,
        tablet: 11,
        tabletMini: 11,
      },
      lineHeight: {
        tower: 16,
        tablet: 14,
        tabletMini: 14,
      },
    },
  },
  components: {
    button: {
      style: 'rounded',
      borderRadius: 64,
    },
    rangeSlider: {
      background: '#76797C', //inactive
      foreground: '#333E4E', //highlight01
      thumb: '#EDEFF1', //background
      thumbBorder: '#76797C', //inactive
    },
  },
}
